import {
  STATUS_APPROVED,
  STATUS_DELETED,
  STATUS_ERROR,
  STATUS_MORE_INFO,
  STATUS_NEW,
  STATUS_PENDING,
  STATUS_PROCESSING,
  STATUS_REJECTED,
} from 'scenes/FinancePage/SA/constants';

export const COLOR_MAP = new Map([
  [STATUS_NEW, 'success'],
  [STATUS_APPROVED, 'success'],
  [STATUS_PENDING, 'processing'],
  [STATUS_PROCESSING, 'processing'],
  [STATUS_ERROR, 'danger'],
  [STATUS_REJECTED, 'danger'],
  [STATUS_MORE_INFO, 'info'],
  [STATUS_DELETED, 'inactive'],
]);
